/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import reduxForm, { Form, InputField } from "components/form";
import { validateEmail as vEmail } from "common/validators";

import { Button } from "components/ui";

const validateRequired = valueString => (valueString ? undefined : "Укажите электронную почту");
const validatePassRequired = valueString => (valueString ? undefined : "Укажите пароль");
const validateEmail = value => (vEmail(value) ? undefined : "Электронная почта не верна");

@reduxForm({ form: "signInForm" })
export default class SignInForm extends Component {
	static propTypes = {
		handleSubmit: PropTypes.func,

		isLoading: PropTypes.bool,
		isError: PropTypes.bool,
		onSubmit: PropTypes.func
	};

	render() {
		const { handleSubmit, isLoading, isError, onSubmit } = this.props;

		return (
			<Form onSubmit={handleSubmit(onSubmit)}>
				<div className="mb-4">
					<i className="feather icon-unlock auth-icon" />
				</div>

				<h4 className="mb-4">Войдите в свой аккаунт</h4>

				<div className="input-group m-b-5">
					<InputField
						name="email"
						label="Электронная почта"
						validate={[validateRequired, validateEmail]}
						prefix={<i className="feather icon-mail" />}
						autoFocus
					/>
				</div>
				<div className="input-group m-b-5">
					<InputField
						password
						name="password"
						label="Пароль"
						validate={[validatePassRequired]}
						prefix={<i className="feather icon-lock" />}
					/>
				</div>

				{isError && <div className="alert alert-danger f-14">Неверный логин или пароль</div>}

				<Button htmlType="submit" type="primary" loading={isLoading}>
					Войти
				</Button>

				<p className="p-t-15 mb-2 text-muted">
					Забыли пароль? <Link to="/forgot">Восстановить</Link>
				</p>

				<div className="p-t-10 f-12">
					Продолжая, вы подтверждаете, что читали наши{" "}
					<a href="/static/policy_rules.pdf" target="_blank">
						Политика & правила
					</a>
				</div>
			</Form>
		);
	}
}
